import { Component, OnInit } from '@angular/core';

import { NotesComponent } from '../../entity-form-components/notes/notes.component';

import { CriticalDate } from '../../objects/critical-dates';
// import { GlobalDataService } from '../../global-data.service';
// import { ContractManagerService } from "../../service/contract-manager.service";

import { FormsModule } from '@angular/forms';

import { AgGridModule } from 'ag-grid-angular';

import { MatInputModule } from '@angular/material/input';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatTabsModule } from '@angular/material/tabs';
import { MatButtonToggleModule } from '@angular/material/button-toggle';


import { EditorModule } from 'primeng/editor';
import { PanelModule } from 'primeng/panel';

@Component({
    selector: 'app-critical-date',
    templateUrl: './critical-date.component.html',
    styleUrls: ['./critical-date.component.css'],
    standalone: true,
    imports: [
      AgGridModule,
      FormsModule,
      MatInputModule,
      MatGridListModule,
      MatDividerModule,
      MatExpansionModule,
      MatTabsModule,
      MatButtonToggleModule,
      PanelModule,
      EditorModule,
      NotesComponent
    ]
  })
export class CriticalDateComponent implements OnInit {

  currentCriticalDate: CriticalDate;

  submitted = false;
  reviewer = true;
  associatedGroupSelected = null;
  waitingForServer = false;

  constructor() { 

    this.currentCriticalDate = {};
  }

  ngOnInit() {

  }


  onSubmit(newCriticalDateForm) {
    console.warn('*** submit critical date *** ALL SUBMIT LOGIC HERE!!!', newCriticalDateForm);
  }

}
